import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

//LOADER
import FancyLoader from './loader/FancyLoader';

//AUTH
const Login = React.lazy(() => import("../components/Auth/Login"));
const Register = React.lazy(() => import("../components/Auth/Register"));
const Recover = React.lazy(() => import("../components/Auth/Recover"));

//USER
const HomeUserPage = React.lazy(() => import("../pages/User/HomeUserPage"));
const KeysUserPage = React.lazy(() => import("../pages/User/KeysUserPage"));
const ActivitiesUserPage = React.lazy(() => import("../pages/User/ActivitiesUserPage"));

//ADMIN
const HomeAdminPage = React.lazy(() => import("../pages/Admin/HomeAdminPage"));
const ActivitiesAdminPage = React.lazy(() => import("../pages/Admin/ActivitiesAdminPage"));
const UserManagementAdminPage = React.lazy(() => import("../pages/Admin/UserManagementAdminPage"));
const KeyManagementAdminPage = React.lazy(() => import("../pages/Admin/KeyManagementAdminPage"));



const AllRoutes = () => {
  return (
    <Suspense fallback={<FancyLoader />}>
      <Routes>

        {/* AUTH */}
        <Route path="/dashboard/login" element={<Login />} />
        <Route path="/dashboard/register" element={<Register />} />
        <Route path="/dashboard/recover" element={<Recover />} />

        {/* USER */}
        <Route path="/dashboard/user-home-page" element={<HomeUserPage />} />
        <Route path="/dashboard/user-keys-page" element={<KeysUserPage />} />
        <Route path="/dashboard/user-activities-page" element={<ActivitiesUserPage />} />

        {/* ADMIN */}
        <Route path="/dashboard/admin-home-page" element={<HomeAdminPage />} />
        <Route path="/dashboard/admin-activities-page" element={<ActivitiesAdminPage />} />
        <Route path="/dashboard/admin-user-management-page" element={<UserManagementAdminPage />} />
        <Route path="/dashboard/admin-key-management-page" element={<KeyManagementAdminPage />} />
      </Routes>
    </Suspense>
  );
};


export default AllRoutes;
